/**
 * =============================================================================
 * sticky-call-now.js
 * =============================================================================

 * =============================================================================
 */

var StickyCallNow = {
  stickyCallNowSectionElement: null,

  init: function() {
    this.stickyCallNowSectionElement = document.querySelector('.section-sticky-call-now');
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  },


  onScrollDown: function(e) {
    if(e.detail.difference > 5) {
      let section = document.querySelector('.section-fixed-height-image');
      if(this.isInViewport(section) == true){
        document.querySelector('.section-sticky-call-now').classList.add('opacity-0');
        document.querySelector('.section-sticky-call-now').classList.remove('opacity-100');
      } else {
        document.querySelector('.section-sticky-call-now').classList.remove('opacity-0');
        document.querySelector('.section-sticky-call-now').classList.add('opacity-100');
      }
     
    }
  },

  onScrollUp: function(e) {
    if(e.detail.difference > 5) {
      let section = document.querySelector('.section-fixed-height-image');
      if(this.isInViewport(section) == true){
        document.querySelector('.section-sticky-call-now').classList.add('opacity-0');
        document.querySelector('.section-sticky-call-now').classList.remove('opacity-100');
      } else {
        document.querySelector('.section-sticky-call-now').classList.remove('opacity-0');
        document.querySelector('.section-sticky-call-now').classList.add('opacity-100');
      }
    }
  },

  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      var difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  },

  isInViewport: function(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  }

}

export default StickyCallNow;